<h4 class="file-a-claim-modal__title">{{ claimMessageInfo?.fileClaimHeader }}</h4>

<div class="file-a-claim-modal__body">
  <div class="mb-20">
    {{ claimMessageInfo?.fileClaimInstructionText }}
  </div>
  <p class="">
    {{ claimMessageInfo?.callLabel }}
    <a [href]="'tel:' + claimMessageInfo?.claimsPhoneNumber" class="link"> {{ claimMessageInfo?.claimsPhoneNumber }}</a>
    <span> {{ claimMessageInfo?.moreInfoLabel }}</span>
  </p>
  <div *ngIf="showChatCTA" class="claim-divider">
    <div class="line">
      <mat-divider></mat-divider>
    </div>
    <div class="text mat-typography">{{ claimMessageInfo?.orLabel }}</div>
    <div class="line">
      <mat-divider></mat-divider>
    </div>
  </div>
  <button *ngIf="showChatCTA" color="accent" (click)="onClickChat()" gtmClick="Chat" gtmLinkURL="/account/file-a-claim" mat-flat-button>
    {{ claimMessageInfo?.chatLabel }}
  </button>
</div>
